import React, { SVGProps } from 'react';

/**
 * Resync icon for the Attio integration.
 *
 * Mirrors the design-system Resync*SmIcon contract (16x16 viewBox, the brand
 * mark centred on (8,8), currentColor fill/stroke) so it behaves
 * identically to its siblings returned by getResyncIconForIntegrationType.
 */
const ResyncAttioIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={['size-6', className].filter(Boolean).join(' ')}
      {...props}
    >
      {/*
        Attio mark: the 40x40 artwork scaled to a 6.67 wide footprint and
        centred on (8,8) — matching the glyph size and centring the DS sibling
        resync icons use (Hubspot/Salesforce are both 6.67 wide).
      */}
      <g transform="translate(4.409 4.415) scale(0.179)">
        <g transform="translate(1.45 4.77)">
          <path
            fill="currentColor"
            d="M36.7345 21.2004L33.6277 16.2659L33.3231 15.8395C32.8357 15.1084 32.0437 14.682 31.1909 14.682L26.1955 14.6211L25.8909 15.2303L19.9208 24.7946L19.6162 25.3429L22.1139 29.3636C22.6013 30.0946 23.3932 30.521 24.2461 30.521H31.2518C32.1047 30.521 32.9575 30.0946 33.384 29.3636L33.6277 28.998L36.7345 24.0027C37.2219 23.0889 37.2219 22.0532 36.7345 21.2004ZM35.7598 23.3326L32.6529 28.3279C32.6529 28.3279 32.6529 28.3889 32.592 28.3889C32.4702 28.5107 32.3483 28.5107 32.2874 28.5107C32.2265 28.5107 32.0437 28.5107 31.9219 28.3279L28.815 23.3326C28.7541 23.2716 28.7541 23.2107 28.6932 23.1498C28.6932 23.0889 28.6323 23.028 28.6323 22.967C28.5713 22.7234 28.5713 22.4797 28.6323 22.1751C28.6932 22.0532 28.6932 21.9314 28.815 21.8096L31.9219 16.8751C31.9828 16.7533 32.1047 16.6923 32.1656 16.6923C32.2265 16.6923 32.2265 16.6923 32.2265 16.6923C32.2265 16.6923 32.2265 16.6923 32.2874 16.6923C32.3483 16.6923 32.5311 16.6924 32.6529 16.8751L35.7598 21.8096C36.0644 22.2969 36.0644 22.8452 35.7598 23.3326Z"
          />
          <path
            fill="currentColor"
            d="M27.5355 9.19882C28.0229 8.40686 28.0229 7.31032 27.5355 6.51837L24.4286 1.5839L24.185 1.15747C23.6976 0.426435 22.9057 0 22.0528 0H15.0471C14.1942 0 13.4022 0.426435 12.9149 1.15747L0.365516 21.2608C0.121839 21.6264 0 22.1137 0 22.5401C0 23.0275 0.121839 23.4539 0.365516 23.8804L3.71608 29.2413C4.20343 30.0332 4.99538 30.4597 5.90917 30.4597H12.9149C13.7678 30.4597 14.6206 30.0332 15.0471 29.3022L15.2907 28.8757L17.7884 24.8551L25.1597 13.0367L27.5355 9.19882ZM26.8045 7.91951C26.8045 8.16319 26.7436 8.40686 26.5608 8.65054L14.316 28.2666C14.1942 28.4493 14.0114 28.4493 13.9505 28.4493C13.8896 28.4493 13.7068 28.4493 13.585 28.2666L10.4781 23.2712C10.1735 22.8447 10.1735 22.2355 10.4781 21.8091L22.7838 2.19309C22.9057 2.01034 23.0884 2.01034 23.1493 2.01034C23.2103 2.01034 23.393 2.01034 23.5149 2.19309L26.6217 7.12756C26.7436 7.37124 26.8045 7.61491 26.8045 7.91951Z"
          />
        </g>
      </g>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M0.666748 7.47858L1.71436 6.43097L2.76197 7.47858"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M15.3335 8.52338L14.2859 9.57099L13.2383 8.52338"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M2.88599 4.36105C4.61492 1.90839 7.83822 1.02283 10.5776 2.24788C13.3169 3.47293 14.8058 6.46578 14.1303 9.38958"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M13.1112 11.6378C11.3822 14.0905 8.15893 14.9761 5.41958 13.751C2.68024 12.526 1.19139 9.53311 1.86683 6.60931"
      />
    </svg>
  );
};

export default ResyncAttioIcon;
